<template>
  <div class="profil">
    <!-- main-area -->
    <main class="fix">
      <!-- breadcrumb-area -->
      <section class="breadcrumb__area breadcrumb__bg">
        <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100"
          :style="{ backgroundImage: `url('assets/img/banner/banner1.png')` }"></div>
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="breadcrumb__content">
                <h2 class="title">Video</h2>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);" @click="$router.push('/')">Beranda</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Video</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div class="breadcrumb__shape">
          <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
          <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
        </div>
      </section>
      <!-- breadcrumb-area-end -->
      <!-- project-area -->
      <section class="project-area">
        <div class="container pb-40">
          <div class="row justify-content-center">
            <div class="blog-post-wrap">
              <div class="sidebar__widget sidebar__widget-two">
                <div class="sidebar__search">
                  <form action="#">
                    <input type="text" v-model="cari_value" @keyup="cari_data()" placeholder="Cari Video" />
                    <button type="button" style="cursor: default;">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M19.0002 19.0002L14.6572 14.6572M14.6572 14.6572C15.4001 13.9143 15.9894 13.0324 16.3914 12.0618C16.7935 11.0911 17.0004 10.0508 17.0004 9.00021C17.0004 7.9496 16.7935 6.90929 16.3914 5.93866C15.9894 4.96803 15.4001 4.08609 14.6572 3.34321C13.9143 2.60032 13.0324 2.01103 12.0618 1.60898C11.0911 1.20693 10.0508 1 9.00021 1C7.9496 1 6.90929 1.20693 5.93866 1.60898C4.96803 2.01103 4.08609 2.60032 3.34321 3.34321C1.84288 4.84354 1 6.87842 1 9.00021C1 11.122 1.84288 13.1569 3.34321 14.6572C4.84354 16.1575 6.87842 17.0004 9.00021 17.0004C11.122 17.0004 13.1569 16.1575 14.6572 14.6572Z"
                          stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-item-wrap">
          <div class="container custom-container-three">
            <div class="row">
              <div class="col-xl-4 col-md-6" v-for="data in list_data" :key="data.id">
                <div class="project-item">
                  <video width="100%" controls class="rounded-video">
                    <source :src="file_path + data.video" type="video/mp4">
                  </video>
                  <div class="project-content">
                    <div class="left-side-content">
                      <h4 class="title">{{ data.judul }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-shape-wrap">
          <img class="dark-opacity" src="assets/img/project/project_shape01.png" alt="Apexa" />
          <img src="assets/img/project/project_shape02.png" alt="Apexa" class="rotateme" />
        </div>
        <div class="pagination-wrap mt-40 mb-5">
          <nav aria-label="Page navigation example">
            <ul class="pagination list-wrap">
              <li class="page-item"><a class="page-link" href="javascript:void(0);" @click="btn_prev" id="pref"><i class="fas fa-angle-double-left"></i></a></li>
              <li class="page-item"><a class="page-link" href="javascript:void(0);">{{ page_first }}</a></li>
              <li class=""><a class="page-link border-0" href="javascript:void(0);">-</a></li>
              <li class="page-item"><a class="page-link" href="javascript:void(0);">{{ page_last }}</a></li>
              <li class="page-item next-page"><a class="page-link" href="javascript:void(0);" @click="btn_next"><i class="fas fa-angle-double-right"></i></a></li>
            </ul>
          </nav>
        </div>
      </section>
      <!-- project-area-end -->
    </main>
    <!-- main-area-end -->
  </div>
</template>

<script>

export default {
  name: 'Profil',

  data() {
    return {
      windowWidth: window.innerWidth,
      file_path: this.$store.state.url.URL_APP + "uploads/",
      unit_kerja: this.$store.state.UNIT_KERJA,
      cek_load_data: true,
      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
    }
  },

  methods: {
    getView: function () {
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_VIDEO + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          kategori: this.kategori,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          this.cek_load_data = false;
        });
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  },

  mounted() {
    this.getView();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
}
</script>